/* CalmRuffy – met en pause les animations des blocs qui ne sont pas à l'écran,
   et les relance dès qu'ils reviennent. Rien ne change visuellement. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var SEL = [
    '.cr-promo', '.cr-ticker', '.cr-head', '.crh-chip-wrap', '.cr-eta2',
    '.kaching-bundles__block', '.kaching-bundles', '.cc-stock-note',
    'button[name="add"]', '.add-to-cart-button', '.cr-review-heading', '.crm',
    '.cr-mo', '.cr-wave-image', '.cr-confidence', '.cr-faq', '.cr-existing-faq',
    '.page-wrapper > footer', '.crf', '.button-custom'
  ].join(',');
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('crp-off', !e.isIntersecting); });
  }, { rootMargin: '150px 0px' });
  function scan() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (seen) { if (seen.has(el)) return; seen.add(el); }
      else { if (el.__crp) return; el.__crp = 1; }
      io.observe(el);
    });
  }
  function start() { scan(); setTimeout(scan, 1500); setTimeout(scan, 4000); window.addEventListener('load', scan); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
